import React, { useState, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import axios from "axios";


export default function SheetMuiStarRatingCard({ safeSheetName, initialAvg = 0, initialCount = 0, onRatingUpdated }) {
  const [avgRating, setAvgRating] = useState(initialAvg);
  const [totalRatings, setTotalRatings] = useState(initialCount);
  const [hoverRating, setHoverRating] = useState(0);
  const containerRef = useRef(null);

  const calculateRating = (e) => {
    if (!containerRef.current) return 0;
    const box = containerRef.current.getBoundingClientRect();
    const x = e.clientX - box.left;
    const width = box.width;
    const rawValue = (x / width) * 5;
    return Math.ceil(rawValue * 2) / 2; // Runden auf 0.5er Schritte
  };

	const submitRating = async (e) => {
	  const finalRating = calculateRating(e);
	  if (finalRating < 0.5) return; // Schutz vor Null-Sterne-Klicks

	  try {
		// ⭐ FIX: Axios übernimmt das JSON-Stringify und die Header automatisch!
		// Wir übergeben das Daten-Objekt direkt als zweites Argument.
		const response = await axios.post(`/sheet/${safeSheetName}/rate`, {
		  rating: finalRating,
		});
		
		// ⭐ FIX: Axios nutzt .status statt .ok und speichert die Antwort in .data
		if (response.status === 200) {
		  const data = response.data;

		  // 1. Lokalen UI-Zustand der Sterne aktualisieren
		  setAvgRating(data.average_rating);
		  setTotalRatings(data.total_ratings);

		  // 2. 🌟 NEU: Den globalen Redux-Store informieren!
		  if (onRatingUpdated) {
			onRatingUpdated(data.average_rating, data.total_ratings);
		  }



		}
	  } catch (error) {
		console.error('Fehler beim Bewerten:', error);
	  }
	};


  const activeRating = hoverRating || avgRating;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
      {/* Interaktiver Stern-Container */}
      <Box
        ref={containerRef}
        onMouseMove={(e) => setHoverRating(calculateRating(e))}
        onMouseLeave={() => setHoverRating(0)}
        onClick={submitRating}
        sx={{
          display: 'flex',
          position: 'relative',
          cursor: 'pointer',
          userSelect: 'none',
          fontSize: '1.75rem',
        }}
      >
        {/* Graue Sterne im Hintergrund */}
        <Box sx={{ color: '#e4e5e9', display: 'flex' }}>
          <StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" />
        </Box>

        {/* Gelbe Sterne im Vordergrund (wird präzise abgeschnitten) */}
        <Box
          sx={{
            color: '#ffc107',
            display: 'flex',
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'hidden',
            width: `${(activeRating / 5) * 100}%`,
            whiteSpace: 'nowrap',
          }}
        >
          <StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" /><StarIcon fontSize="inherit" />
        </Box>
      </Box>

      {/* Textanzeige */}
      <Typography variant="body2" sx={{ color: '#555', fontWeight: 500, mt: 0.5 }}>
        <strong>{avgRating.toFixed(1)}</strong> ({totalRatings} {totalRatings === 1 ? 'Bewertung' : 'Bewertungen'})
      </Typography>
    </Box>
  );
}
